import Grid from '@mui/material/Grid/Grid'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import GuardedRoute from '../components/route-guards/GuardedRoute'
import { CenteredProgress } from '../spark_libs_deprecated/CenteredProgress'

const AdminContainer = React.lazy(() => import('./admin/AdminContainer.layout'))
const AuthenticationContainer = React.lazy(() => import('./authentication/AuthenticationContainer.layout'))
const AuctionContainer = React.lazy(() => import('./auction/AuctionContainer.layout'))

const RootContainer = () => {
    return (
        <div>
            <Grid>
                <React.Suspense fallback={<CenteredProgress />}>
                    <Switch>
                        <GuardedRoute path="/admin" component={AdminContainer} />

                        <GuardedRoute path="/auction">
                            <AuctionContainer />
                        </GuardedRoute>
                        <Route component={AuthenticationContainer} />
                    </Switch>
                </React.Suspense>
            </Grid>
        </div>
    )
}

export default RootContainer
